import React, { PureComponent } from 'react';
import moment from 'moment';
import PT from 'prop-types';
import { connect } from 'react-redux';
import { Popup, Table } from 'semantic-ui-react';
import classNames from 'classnames';
import Link from 'redux-first-router-link';
import { selectMatchupAnalysisState, MATCHUP_ANALYSIS_VIEW } from './module/analysis';
import { selectPredictionsState } from '../module/predictions';
import { goToView } from '../../../routes.global';
import { goPlayer } from '../../Player/module/player';
import classes from './matchupAnalysis.css';
import PlainTable from '../../../components/DataTable/PlainTable';
import { selectTeamLogoAndColor } from '../../../../store/reducers/teams.selectors';
import FiltersHeader from '../../../../app/components/FiltersHeader';
import PrimaryDropdown from '../../../components/FilterComponents/PrimaryDropdown';
import {
  selectToolDescriptionsState,
} from '../../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../../components/ToolDescriptions/ToolDescriptions';

/* eslint camelcase: 0 */
/* eslint no-return-assign: 0 */

const formatMatches = matches => {
  return matches.map(match => (
    {
      text: `${match.away_team_name} @ ${match.home_team_name}`,
      key: match.game_id,
      value: match.game_id,
    }));
}

const formatUpdateDatetime = (timestamp) => {
  const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    timeZone: 'America/New_York',
    timeZoneName: "short"
  }).format(timestamp*1000);

  const dateTokens = dateTimeFormat.split(',').slice(0, 3);
  const timeTokens = dateTimeFormat.split(',').slice(3);
  const dateString = `${dateTokens.join(',')}, at ${timeTokens.join(',').trim()}`;

  return dateString;
}

const mapStateToProps = state => {
  const {
    matchupId,
    matchups,
    formulaId,
    matchupData,
    pregame,
    home_team_stats,
    away_team_stats,
    home_team_record_summary,
    away_team_record_summary,
    home_team_record,
    away_team_record,
    home_team_defensive_matchup,
    away_team_defensive_matchup,
    hasLoaded,
    error,
  } = selectMatchupAnalysisState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);
  let matchupsThisWeek = selectPredictionsState(state).matchups;
  if (!matchupsThisWeek.length) {
    matchupsThisWeek = matchups;
  }
  const formattedMatchupsThisWeek = matchupsThisWeek && formatMatches(matchupsThisWeek);

  return {
    hasLoaded,
    selectedMatchup: matchupId,
    selectedProfile: formulaId,
    matchupData,
    pregame,
    home_team_stats,
    away_team_stats,
    home_team_record_summary,
    away_team_record_summary,
    home_team_record,
    away_team_record,
    home_team_defensive_matchup,
    away_team_defensive_matchup,
    error,
    home_logoAndColor:
      hasLoaded && selectTeamLogoAndColor(state, matchupData.home_team_id),
    away_logoAndColor:
      hasLoaded && selectTeamLogoAndColor(state, matchupData.away_team_id),
    formattedMatchupsThisWeek,
    toolDescriptions,
    toolsLoaded,
  };
};
const actions = {
  goToView,
};
class ConnectedMatchupAnalysis extends PureComponent {

  processText = text => (
    {
    __html: text?text.replace(/[\u{0080}-\u{FFFF}]/gu, "'").replace(/\\'/g, "'").replace('../../../', 'http://www.thehuddle.com/'):'',
  });

  renderMatchupGraphic = () => {
    if (!this.props.hasLoaded) return <div />;

    const {
      home_team_city: homeCity,
      home_team_name: homeName,
      away_team_city: awayCity,
      away_team_name: awayName,
      pred_home_score: homeScore,
      pred_away_score: awayScore,
      home_team_helmet: homeHelmetImg,
      away_team_helmet: awayHelmetImg,
      pred_line: line,
      pred_ou: ou,
    } = this.props.matchupData;

    return (
      <div className={classes.matchupGraphic}>
        <div className={classes.scoresWrapper}>
          <div className={classes.awayHelmet}>
            <img src={awayHelmetImg} alt={`${awayCity} ${awayName} Helmet`} />
          </div>
          <div className={classes.predictionTextWrapper}>
            <div className={classes.scores}>
              {awayScore}
              <span className={classes.pointer}>
                <span className={homeScore < awayScore ? classes.pointLeft : classes.pointRight} />
              </span>
              {homeScore}
            </div>
            <div className={classes.prediction}>PREDICTION</div>
          </div>
          <div className={classes.homeHelmet}>
            <img src={homeHelmetImg} alt={`${homeCity} ${homeName} Helmet`} />
          </div>
        </div>
        {
          ou===null | ou===undefined | ou===''?
            <div className={classes.lineou}>{`${line?line:''}`}</div>
            :<div className={classes.lineou}>{`${line}, O/U = ${ou}`}</div>
        }
      </div>
    );
  };

  renderSummary = () => {
    const { pregame: { summary } } = this.props;
    return (
      <div className={classes.summaryContent} >
        <h3 className={classes.sectionLabel}>Summary</h3>
        <div dangerouslySetInnerHTML={this.processText(summary)} />
      </div>
    );
  };

  renderBettingInfo = () => {
    const betting_info = this.props.pregame.betting_info;
    if (!betting_info) {
      return null
    }
    return (
      <div className={classes.bettingInfo} >
        <div dangerouslySetInnerHTML={this.processText(betting_info)} />
      </div>
    );
  };

  renderDefensiveMatchups = teamType => {
    const rowData = [];
    const { home_abbr, away_abbr } = this.props.matchupData;
    if (teamType === 'home') {
      const { home_gained_ranks, away_allowed_ranks } = this.props.home_team_defensive_matchup;
      rowData.push(
        {
          ...home_gained_ranks,
          label: 'Gaining Fantasy Points',
          team: home_abbr,
        },
        {
          ...away_allowed_ranks,
          label: 'Preventing Fantasy Points',
          team: away_abbr,
        },
      );
    } else {
      const { away_gained_ranks, home_allowed_ranks } = this.props.away_team_defensive_matchup;
      rowData.push(
        {
          ...away_gained_ranks,
          label: 'Gaining Fantasy Points',
          team: away_abbr,
        },
        {
          ...home_allowed_ranks,
          label: 'Preventing Fantasy Points',
          team: home_abbr,
        },
      );
    }

    const colGroups = [
      {
        name: '',
        columns: ['label', 'team', 'QB', 'RB', 'WR', 'TE', 'PK', 'DF'],
        colLabels: ['RANKS (1-32, 1=BEST)', 'TEAM', 'QB', 'RB', 'WR', 'TE', 'PK',
          'DEF'],
      },
    ];
    return (
      <PlainTable
        data={rowData}
        colGroups={colGroups}
        teamColor={''}
        disableSort
        className={classes.table}
      />
    );
  };

  renderTeamRecord = teamType => {
    const rowData = [];
    const { season } = this.props.matchupData;
    let recordSummary = null;
    let record = null;
    let color = null;
    let logo = null;
    let name = null;
    if (teamType === 'home') {
      ({ home_team_record: record, home_team_record_summary: recordSummary } = this.props);
      ({ color, logo } = this.props.home_logoAndColor);
      name = this.props.matchupData.home_team_city;
    } else {
      ({ away_team_record: record, away_team_record_summary: recordSummary } = this.props);
      ({ color, logo } = this.props.away_logoAndColor);
      name = this.props.matchupData.away_team_city;
    }
    const columns = [];
    const colLabels = [];
    const recordRow = {};
    record.forEach((week, weekIndex) => {
      columns.push(String(weekIndex));
      colLabels.push(`wk ${week.week}\n${week.opponent || week.oppenent}`);
      recordRow[String(weekIndex)] = week.result && week.result !== '-' ? <span><strong>{week.result}</strong>{`\n${week.score}`}</span> : null;
    });

    return (
      <div className={classes.recordTable}>
        <div
          className={classes.matchupSectionLabel}
          style={{ backgroundColor: color }}
        >
          <img className={classes.logo} src={logo} alt={`${name} logo`} />
          {`${name} ${season} Season - (${recordSummary})`}
        </div>
        <PlainTable
          data={[recordRow]}
          colGroups={[{ name: '', columns, colLabels }]}
          teamColor={''}
          disableSort
          equalWidthCols
          centerFirstCol
          fittedText
          fixFirstColumn={false}
          className={classes.table}
        />
      </div>
    );
  };

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(MATCHUP_ANALYSIS_VIEW, { params: { formulaId: value, matchupId: this.props.selectedMatchup } });
    }
  }

  handleChangeMatchup = (event, { value }) => {
    if (this.props.selectedMatchup !== value) {
      this.props.goToView(MATCHUP_ANALYSIS_VIEW, { params: { formulaId: this.props.selectedProfile, matchupId: value } });
    }
  }

  renderTeam = (team, { color, logo, name }) => {
    const wrapperClass = classNames(
      classes.tableWrapper,
    );
    if(team.length==0){
      return (<div></div>)
    }
    return (
      <div className={wrapperClass}>
        <div
          className={classes.matchupSectionLabel}
          style={{ backgroundColor: color, borderLeft: '1px solid #fff',
    borderRight: '1px solid #fff'}}
        >
          <img className={classes.logo} src={logo} alt={`${name} logo`} />
          {`${name} Projections`}
        </div>
        <Table unstackable celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                {team[0].team_abbr} {team[0].opponent_location} {team[0].opponent_team_abbr}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>FFPT</span>}
                  position="top center"
                  content="Total Fantasy Points (Calculated)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>Rush</span>}
                  position="top center"
                  content="Projected rushing stats (yardage, touchdowns)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>Catch</span>}
                  position="top center"
                  content="Projected receiving stats (catches-yardage, touchdowns)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center">
                <Popup
                  trigger={<span>Pass</span>}
                  position="top center"
                  content="Projected passing stats (yardage, touchdowns)"
                  wide
                  className={classes.statPopup}
                />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {team.map(player => this.renderPlayerRow(player))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  renderPlayerRow = ({
    player_id: playerId,
    fpts,
    fname,
    lname,
    position,
    stats,
  }) => {

    const calcFirstName = (fname, lname) => {

       let displayFirstName = fname;
       if (fname.length + lname.length > 11) {
        displayFirstName = fname.toString().substring(0,1) + '.';
       }
       return displayFirstName;
    };

    const defineStat = statId => {
      const statIdArray = stats.filter(individualStat => individualStat.stat === statId);

      let statValue;

      if (statIdArray.length > 0) {
        statValue = statIdArray[0].stat_value_total;
      } else {
        statValue = 0;
      }

      return statValue;
    };

    const passingYards = defineStat('pa_yd');
    const passingTDs = defineStat('pa_td');
    const rushingYards = defineStat('ru_yd');
    const rushingTDs = defineStat('ru_td');
    const receptions = defineStat('rec');
    const receivingYards = defineStat('re_yd');
    const receivingTDs = defineStat('re_td');
    const fieldGoalsMade = defineStat('fgm');
    const extraPointsMade = defineStat('xpm');

    return (
      <Table.Row key={playerId}>
        <Table.Cell textAlign="center">{position}</Table.Cell>
        <Table.Cell singleLine className={classes.playerCell}>
          <Link
            to={goPlayer(playerId, `${fname}-${lname}`)}
            className={classes.playerName}
          >
            {calcFirstName(fname, lname)} {lname}
          </Link>
        </Table.Cell>
        <Table.Cell textAlign="center">{fpts}</Table.Cell>
        {position === 'PK'
          ? (<Table.Cell textAlign="center">
            {fieldGoalsMade > 0
              ? (<span>{fieldGoalsMade}FG</span>)
              : '-'
            }
          </Table.Cell>)
          : (<Table.Cell textAlign="center">
            {rushingYards > 0 || rushingTDs > 0
                 ? (<span>{rushingYards},{rushingTDs}</span>)
                 : '-'
               }
          </Table.Cell>)
        }
        {position === 'PK'
          ? (<Table.Cell textAlign="center">
            {extraPointsMade > 0
              ? (<span>{extraPointsMade}XP</span>)
              : '-'
            }
          </Table.Cell>)
          : (<Table.Cell textAlign="center">
            {receptions > 0 || receivingTDs > 0
              ? (<span>{receptions}-{receivingYards},{receivingTDs}</span>)
              : '-'
            }
          </Table.Cell>)
        }
        <Table.Cell textAlign="center">
          {passingYards > 0 || passingTDs > 0
            ? (<span>{passingYards},{passingTDs}</span>)
            : '-'
          }
        </Table.Cell>
      </Table.Row>
    );
  }

  renderAnalysisSection = teamType => {
    let analysis,
      color,
      logo,
      name,
      stats = null;
    if (teamType === 'home') {
      analysis = this.props.pregame.home_analysis;
      name = this.props.matchupData.home_team_city;
      ({ color, logo } = this.props.home_logoAndColor);
      stats = this.props.home_team_stats;
    } else {
      analysis = this.props.pregame.away_analysis;
      name = this.props.matchupData.away_team_city;
      ({ color, logo } = this.props.away_logoAndColor);
      stats = this.props.away_team_stats;
    }
    if(!stats){
      return <div></div>
    }
    return (
      <div>
        <div
          className={classes.matchupSectionLabel}
          style={{ backgroundColor: color }}
        >
          <img className={classes.logo} src={logo} alt={`${name} logo`} />
          {`${name} Matchup Analysis`}
        </div>
        <div className={classes.matchupSectionContent}>
          {this.renderTeam(stats, { color, logo, name })}
          <div
            dangerouslySetInnerHTML={this.processText(analysis)}
          />
          <div className={classes.defenseMatchupsTable}>
            <div
              className={classes.matchupSectionLabel}
              style={{ backgroundColor: color }}
            >
              <img className={classes.logo} src={logo} alt={`${name} logo`} />
              {`${name} Defensive Matchup`}
            </div>
            {this.renderDefensiveMatchups(teamType)}
          </div>
          {this.renderTeamRecord(teamType)}
        </div>
      </div>
    );
  };

  renderAnalysisLastUpdate = () => {
    const { matchupData: { analysis_updated_at } } = this.props;
    let dateString = "Not Available"
    if (analysis_updated_at) {
      dateString = formatUpdateDatetime(analysis_updated_at)
    }
    return (
      <div className={classes.lastUpdatedAt}>
        <b>Updated:</b> {dateString} 
      </div>
    )
  }

  componentDidMount() {
    // Hides content gate mask
    let cgm = document.getElementById('contentGateMask');
    if ( cgm != null ) {
      cgm.style.visibility = 'hidden';
    }
  }

  render() {
    const { selectedProfile, selectedMatchup, formattedMatchupsThisWeek, hasLoaded, toolDescriptions,
      toolsLoaded } = this.props;
    const { home_team_city = '',
      home_team_name = '',
      away_team_city = '',
      away_team_name = '',
      start_date = '',
      venue_name = '',
      timezone = '', published
    } = hasLoaded && this.props.matchupData;
    const matchupTitle = away_team_city ? `${away_team_city} ${away_team_name} at ${home_team_city} ${home_team_name}` : 'Loading...';
    const subtitle = `${start_date ? `${moment(start_date).format('dddd, MMM Do YYYY h:mm a')} ${timezone}` : ''} ${venue_name || ''}`;
    return (
      <div>
        <div className={classes.filtersWrapper}>
          {this.renderMatchupGraphic()}
          <FiltersHeader
            title={`Game Predictions: ${matchupTitle}`}
            description={toolsLoaded && toolDescriptions.tool_descriptions.game_predictions.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.game_predictions.text}
            />)}
            seasonType="seasons"
            statType="stats"
            selectedYear={null}
            selectedProfile={selectedProfile}
            onChangeProfile={this.handleChangeProfile}
            onChangeYear={this.handleChangeYear}
            showDate={false}
            showYear={false}
            showAlternateSubtitle
            alternateSubtitle={subtitle}
          >
            <PrimaryDropdown
              choices={formattedMatchupsThisWeek}
              activeItem={selectedMatchup}
              onChange={this.handleChangeMatchup}
              label={'Matchup: '}
            />
          </FiltersHeader>
        </div>
        {
          this.props.hasLoaded  &&  published ? (
          <div>
            {this.renderBettingInfo()}
            {this.renderAnalysisLastUpdate()}
            {this.renderSummary()}
            {this.renderAnalysisSection('away')}
            {this.renderAnalysisSection('home')}
          </div>
          ):<div className={classes.noResults}>No data available for the current criteria. Please try adjusting the filters above.</div>
        }
        </div>
    );
  }
}

export default connect(mapStateToProps, actions)(ConnectedMatchupAnalysis);



// WEBPACK FOOTER //
// ./src/app/views/Predictions/MatchupAnalysis/MatchupAnalysis.js